import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Container from '../Container';
import Message from '../Message';
import Icon from '../Icon';
import './styles.css';

export const EVENTUI_ENHANCED_ERROR_TYPE = {
  NETWORK: 'NETWORK',
  GRAPHQL: 'GRAPHQL',
};

export const EnhancedError = (props) => {
  const { iconName, size, className, errorType, error } = props;

  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'development') {
    console.log(`<EnhancedError errorType="${errorType}" />. See full error below...`);
    console.dir(error);
  }

  if ([EVENTUI_ENHANCED_ERROR_TYPE.NETWORK, EVENTUI_ENHANCED_ERROR_TYPE.GRAPHQL].includes(errorType)) {
    return (
      <Container className={classNames('eventui-enhanced-error-container', className)}>
        <Message size={size} warning className={classNames('eventui-enhanced-error', className)}>
          <Icon size={size} className="eventui-enhanced-error-icon large" name={iconName} />
          <Message.Content>Sorry! Something went wrong. We could not complete your request, please try a new search.</Message.Content>
        </Message>
      </Container>
    );
  }
};

EnhancedError.propTypes = {
  iconName: Icon.propTypes.name,
  size: Icon.propTypes.size,
  refetch: PropTypes.func,
  className: PropTypes.string,
  errorType: PropTypes.oneOf(Object.values(EVENTUI_ENHANCED_ERROR_TYPE)),
  error: PropTypes.object,
};

export default EnhancedError;
